import { render, staticRenderFns } from "./AcuteChronicChart.vue?vue&type=template&id=7bd8361a&scoped=true"
import script from "./AcuteChronicChart.vue?vue&type=script&lang=js"
export * from "./AcuteChronicChart.vue?vue&type=script&lang=js"
import style0 from "./AcuteChronicChart.vue?vue&type=style&index=0&id=7bd8361a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8361a",
  null
  
)

export default component.exports